const $ = require("jquery");

window.jQuery = $;
window.$ = $;

// require('jquery-validation');
require ('bootstrap');
window.toastr = require('toastr');

import swal from "sweetalert2";
window.swal = swal;

// require("popper.js"); // dépendance pour les tooltips ? à confirmer...

/////JQUERY-UI/////
// require('jquery-ui'); // Cette ligne ne charge rien du tout...
// Il faut charger les widget un par un
import "jquery-ui/ui/widgets/autocomplete.js"; // accueil estimateur

//Import here the specific librairies for backoffice
import "jquery-validation/dist/localization/messages_fr.js";
require("jquery-ui");

/////SWITCHERY/////
window.Switchery = require("switchery");

/////SPARKLINE/////
// require("sparkline"); // utilisé ?

require("tableheadfixer");

window.lozad = require("lozad");

require("../../assets/vendor/hegyd/core/js/hegyd-core");

require("./frontend/vendor/modernizr-custom");
require("./frontend/vendor/plugins");
require("../../assets/vendor/bootstrap-4.3.1-dist/js/bootstrap.bundle.js");

require('bootstrap-select/dist/js/bootstrap-select.min.js');
require('bootstrap-select/dist/js/i18n/defaults-fr_FR.min.js');

require('./frontend/utils/init-bootstrap-select');
require('./frontend/utils/hegyd-geolocator');
require('./frontend/utils/communication-modal');
require('./frontend/utils/etrennes-modal');
require('./frontend/utils/etrennes-countdown');
require('./frontend/utils/ope-estimation');

require('./frontend/global');
require('./frontend/utils/start');

require("../../assets/vendor/codyhouse-framework/main/assets/js/util.js");
require("../../assets/vendor/codyhouse-framework/main/assets/js/scripts.js");
require("../../assets/vendor/jquery-slimscroll/jquery.slimscroll.js");
require("../../assets/vendor/jquery-form/jquery.form.js");

require("../../assets/vendor/hegyd/core/dependencies/switchery/dist/switchery.js");

require("../../assets/vendor/hegyd/newsletters/js/modal_subscription");
require("../../assets/vendor/hegyd/newsletters/js/subscription_newsletters");

require("./frontend/shops/store-locator");
//require("./frontend/pages/index/results");
require("./frontend/pages/join-us");

require("./frontend/utils/smooth-scroll");
require("./frontend/utils/popup");

require('../../assets/vendor/hegyd/core/dependencies/jquery-ui/ui/widgets/datepicker');
require('../../assets/vendor/hegyd/core/dependencies/bootstrap-datepicker');
require('../../assets/vendor/hegyd/core/dependencies/bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min');

const Kernel = require("./frontend/utils/Kernel");
window.Kernel = new Kernel();

window.Kernel.registerComponent('ShopIndex', require('./frontend/components/ShopIndex').default);
window.Kernel.registerComponent('NewsSelectPicker', require('./frontend/components/NewsSelectPicker').default);
window.Kernel.registerComponent('ServicesIndex', require('./frontend/components/ServicesIndex').default);
window.Kernel.registerComponent('SeosConversion', require('./frontend/components/SeosConversion').default);
window.Kernel.registerComponent('ProgressBar', require('./frontend/components/ProgressBar').default);
window.Kernel.registerComponent('Redirect', require('./frontend/components/Redirect').default);
window.Kernel.registerComponent('GoogleRecaptcha', require('./frontend/components/GoogleRecaptcha').default);
window.Kernel.registerComponent('MapBienIci', require('./frontend/components/MapBienIci').default);
window.Kernel.registerComponent('QuestionAnswer', require('./frontend/components/QuestionAnswer').default);
window.Kernel.registerComponent('SearchLexique', require('./frontend/components/SearchLexique').default);
window.Kernel.registerComponent('RedirectToEstimator', require('./frontend/components/RedirectToEstimator').default);

window.Kernel.mountComponents($("html"));
